import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';
import AuthStore from 'stores/AuthStore';
import SidebarStore from 'stores/SidebarStore';
import AdminSidebar from 'components/pure/admin/AdminSidebar';

/**
 * AdminSidebarContainer is an AltContainer for <AdminSidebar/>.
 */
class AdminSidebarContainer extends React.Component {
  static getStores() {
    return [AuthStore, SidebarStore];
  }

  static getPropsFromStores() {
    const sidebarState = SidebarStore.getState();

    return {
      sidebarOpen: sidebarState.get('open'),
    };
  }

  render() {
    return (
      <AltContainer>
        <AdminSidebar {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(AdminSidebarContainer);
